import React, {Component} from 'react';
import {withFirebase} from "../Firebase";
import Header from "../Header";
import languages from "../../utils/languages";
import {withAdmin} from "../Session/context";
import SubmissionEntry from "../Submission_Entry";
import Submission from "../Submission";
import {Link} from "react-router-dom";

class PageApprove extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submissions: [],
            existing: {}
        }
    }

    componentDidMount() {
        this.props.firebase.getSubmissions().onSnapshot((snapshot) => {
            const submissions = [];
            snapshot.forEach(doc => {
                submissions.push({...doc.data(), id: doc.id});
            });
            this.setState({ submissions: submissions});
            this.loadExistingTranslations(submissions)
        });

        this.props.firebase.getProjects().then(projects => {
            this.setState({ projects: projects })
        });
    }

    loadExistingTranslations = (submissions) => {
        const needToLoad = {};
        submissions.forEach(sub => {
            needToLoad[sub.project] = { ...needToLoad[sub.project], [sub.language]: true }
        });

        const projectsToLoad = Object.keys(needToLoad);
        projectsToLoad.forEach(project => {
            const languages = Object.keys(needToLoad[project]);
            languages.forEach(language => {
                if(!this.state.existing[project] || !this.state.existing[project][language]) {
                    this.props.firebase.getExistingTranslations(project, language).then(existing => {
                        this.setState((prevState, props) => ({
                            existing: {
                                ...prevState.existing,
                                [project]: {
                                    ...prevState.existing[project],
                                    [language]: existing
                                }
                            }
                        }))
                    });
                }
            })
        });
    };

    getOriginalString(projectId,key) {
        return this.state.projects.find(p => p.id === projectId).strings[key]
    }

    getExistingTranslation(projectId,language,key) {
        try {
            return this.state.existing[projectId][language][key];
        } catch (e) {
            return null
        }
    }

    rejectSubmissionEntry = (event,submissionId,key) => {
        event.preventDefault();
        this.props.firebase.rejectSubmissionEntry(submissionId,key);
    };

    approveRemaining = (event,submissionId) => {
        event.preventDefault();
        this.props.firebase.approveSubmission(submissionId);
    };

    rejectRemaining = (event,submissionId) => {
        // just delete the document!
        event.preventDefault();
        this.props.firebase.deleteSubmission(submissionId);
    };

    render() {

        if(!this.state.projects) return null;

        const listItems = this.state.submissions.map((sub) => {
            const entries = Object.entries(sub.translations);
            const translations = entries.map(entry => {
                return (
                    <React.Fragment key={`${sub.id}-${entry[0]}`}>
                        <SubmissionEntry rejectEntryListener={(event) => this.rejectSubmissionEntry(event,sub.id,entry[0])} original={this.getOriginalString(sub.project,entry[0])} translation={entry[1]} existing={this.getExistingTranslation(sub.project,sub.language,entry[0])} />
                        <hr />
                    </React.Fragment>
                )
            });
            return (
                <Submission key={sub.id} project={sub.project} language={languages[sub.language]} approveListener={(event) => this.approveRemaining(event,sub.id)} rejectListener={(event) => this.rejectRemaining(event,sub.id)}>
                    <br /><hr />
                    {translations}
                </Submission>
            );
        });

        return (
            <div>
                <Header title={`Approve`} subtitle={`Translations`} />
                <p>
                    <Link to={`/admin/download`}>Download</Link>
                    &nbsp;&nbsp;&nbsp;&nbsp;<Link to={`/admin/upload`}>Upload</Link>
                    &nbsp;&nbsp;&nbsp;&nbsp;<Link to={`/admin/seed`}>Seed</Link>
                </p>
                {listItems}
            </div>
        );
    }
}

export default withAdmin(withFirebase(PageApprove));